// extracted by mini-css-extract-plugin
export default {"wrapper":"CompanyDetails_wrapper__6UfmP","box":"CompanyDetails_box__n0Ezc"};